import { useEffect, useMemo } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { NavDropdown } from 'react-bootstrap';

import { RootState } from '../../app/Store';
import Chip from '../../common/components/Chip';
import Icon from '../../common/components/Icon';
import Tooltip from '../../common/components/Tooltip';
import useIsScreenMdUp from '../../common/hooks/useIsScreenMdUp';
import { getRoutePath } from '../../common/utility';
import { NEW_ITEM_URL_ID } from '../../common/constants';
import { useDispatch, useSelector } from '../../common/store/redux';
import * as GroceryListsActions from '../../groceryList/store/GroceryListsActions';
import NavLink from './NavLink';

const messages = defineMessages({
  groceryLists: {
    id: 'nav.groceryLists',
    description: 'Grocery Lists',
    defaultMessage: 'Shopping Lists',
  },
  grocery_list_create: {
    id: 'nav.grocery_list_create',
    description: 'Button to create a new grocery list',
    defaultMessage: 'New list',
  },
});

const GroceryListMenuItem: React.FC = () => {
  const intl = useIntl();
  const { formatMessage } = intl;

  const dispatch = useDispatch();
  const isScreenMdUp = useIsScreenMdUp();

  const groceryListsState = useSelector((state: RootState) => state.groceryLists);
  const { items } = groceryListsState;
  useEffect(() => {
    dispatch(GroceryListsActions.load());
  }, []);
  const sumItemCount = useMemo(() => items?.reduce((a, b) => a + b.item_count, 0), [items]);

  const listsJsx = items?.map(list => (
    <NavLink to={getRoutePath(`/grocery-lists/${list.slug}`)} key={list.id}>
      <span className='title'>{list.title}</span>
      {list.shares?.length > 0 && <Tooltip id={`${list.title}-menu-item-tooltip`} tooltip={intl.messages['grocery_list.header.shared_tooltip'] as string}><Icon className='grocery-list-item-count' icon='share' /></Tooltip>}
      <Chip color='secondary' className='grocery-list-item-count'>{list.item_count}</Chip>
    </NavLink>
  ));

  return (
    <NavDropdown
        id = 'grocery-lists-dropdown'
        title = {(
          <>
            <span>{formatMessage(messages.groceryLists)}</span>
            {sumItemCount != null && sumItemCount > 0 && <Chip color='secondary' className='grocery-list-item-count'>{sumItemCount}</Chip>}
          </>
        )}
        drop = {isScreenMdUp ? 'start' : 'down'}
        align = {isScreenMdUp ? undefined : 'end'}
        className = 'dropdown-toggle-start grocery-lists-dropdown'>
      {listsJsx}
      {listsJsx && listsJsx.length > 0 && <NavDropdown.Divider />}
      <NavLink to={getRoutePath(`/grocery-lists/${NEW_ITEM_URL_ID}`)}>{formatMessage(messages.grocery_list_create)}</NavLink>
    </NavDropdown>

  );
};

export default GroceryListMenuItem;
